import { TreeItemIndex, TreeItem } from 'react-complex-tree'

import { SimpleTreeItemData } from '../types.js'

export const ROOT_INDEX = 'root'

export function createRootTreeItem({
  children,
}: {
  children: TreeItemIndex[]
}): TreeItem<SimpleTreeItemData> {
  return {
    index: ROOT_INDEX,
    isFolder: false,
    data: {
      title: ROOT_INDEX,
      type: 'simple',
      render: () => <div />,
    },
    children,
  }
}
